/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_WineInputs */

const en_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine Wine`)
};

const es_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinos finos`)
};

const fr_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vins fins`)
};

const de_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edle Weine`)
};

const ja_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高級ワイン`)
};

const zh_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精品葡萄酒`)
};

const ar_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبيذ فاخر`)
};

const id_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggur Berkualitas`)
};

const it_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vini Pregiati`)
};

const ru_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Элитные вина`)
};

const pt_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinhos Finos`)
};

const ko_listing_category_wine = /** @type {(inputs: Listing_Category_WineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고급 와인`)
};

/**
* | output |
* | --- |
* | "Fine Wine" |
*
* @param {Listing_Category_WineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_wine = /** @type {((inputs?: Listing_Category_WineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_WineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_wine(inputs)
	if (locale === "es") return es_listing_category_wine(inputs)
	if (locale === "fr") return fr_listing_category_wine(inputs)
	if (locale === "de") return de_listing_category_wine(inputs)
	if (locale === "ja") return ja_listing_category_wine(inputs)
	if (locale === "zh") return zh_listing_category_wine(inputs)
	if (locale === "ar") return ar_listing_category_wine(inputs)
	if (locale === "id") return id_listing_category_wine(inputs)
	if (locale === "it") return it_listing_category_wine(inputs)
	if (locale === "ru") return ru_listing_category_wine(inputs)
	if (locale === "pt") return pt_listing_category_wine(inputs)
	return ko_listing_category_wine(inputs)
});